import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../../styles/Main.scss";

import { getRequest, postRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";

import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import AddSuburb from "./AddSuburb";
import BulkSuburbUpload from "./BulkSuburbUpload";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";
const { Search } = Input;
//
const SuburbList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [CityList, setCityList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [newCityAdded, setNewCityAdded] = useState(false);
  const [suburbId, setSuburbId] = useState(null);
  const [modalKey, setModalKey] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getCityList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("suburb/", state);
        if (apiResponse.data.results.success) {
          setCityList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_list_City"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getCityList();
  }, [state, newCityAdded, reload, t]);

  // useEffect(() => {
  //   getzoneName();
  // }, []);

  // const getzoneName = async () => {
  //   try {
  //     const response = await getRequest("zone/?no_pagination=true");

  //   } catch (error) {
  //     // setapiLoading(false);
  //   }
  // };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "area" && sortOrder === "ascend") {
      sortingEnumKey = "area";
    }
    if (sortField === "area" && sortOrder === "descend") {
      sortingEnumKey = "-area";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "city" && sortOrder === "ascend") {
      sortingEnumKey = "city__name";
    }
    if (sortField === "city" && sortOrder === "descend") {
      sortingEnumKey = "-city__name";
    }

    if (sortField === "country" && sortOrder === "ascend") {
      sortingEnumKey = "country__name";
    }
    if (sortField === "country" && sortOrder === "descend") {
      sortingEnumKey = "-country__name";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    form.setFieldsValue({ search: "" });
  };

  const [checkedList, setCheckedList] = useState([
    "area",
    "zone",
    "state",
    "country",
    "operation",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Suburb",
      dataIndex: "area",
      key: "area",
      sorter: true,
    },

    {
      title: "Run",
      dataIndex: "zone_name",
      key: "zone",
      sorter: true,
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state",
      sorter: true,
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country",
      sorter: true,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
          {authUserData()?.permission.includes("common|change_suburb") && (
            <Editicon
              onClick={() => handleUpdate(record.id)}
              style={{ cursor: "pointer" }}
            />
          )}
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          > */}
          {authUserData()?.permission.includes("common|delete_suburb") && (
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    // Update columns visibility based on checkedList
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="area">Suburb</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="zone">Run</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="state">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="country">Country</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleUpdate = (id) => {
    setModalKey((prevKey) => !prevKey);
    setSuburbId(id);
    showModal();
  };
  const handleAdd = () => {
    setSuburbId(null);
    showModal();
  };

  const handleArchive = async (id = []) => {
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    setReload(reload);
    try {
      let apiResponse = await postRequest("suburb/archive-suburb/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("Suburb Archived Successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("Error In Archive Subrub"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);

  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };

  const colors = ["#737373"];
  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Suburb</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Suburb")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Create New Suburb For Organizing.
                </span>
              }
            > */}
            {authUserData()?.permission.includes("common|add_suburb") && (
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={handleAdd}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("pl_add_suburb")}
              </Button>
            )}
            {/* </Tooltip> */}
            <Modal
              className="ModelPopupSec"
              title={suburbId ? t("Edit Suburb") : t("Add Suburb")}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              closable={false}
              wrapClassName="modal-wrapper"
              keyboard={false}
            >
              <AddSuburb
                reload={reload}
                setReload={setReload}
                handleCancel={handleCancel}
                suburbId={suburbId}
                modalKey={modalKey}
              />
            </Modal>

            <Modal
              className="ModelPopupSec"
              title="Upload File"
              open={isModalOpenBulk}
              onOk={handleOkBulk}
              onCancel={handleCancelBulk}
              closable={false}
              wrapClassName="modal-wrapper"
            >
              <BulkSuburbUpload
                setNewCityAdded={setNewCityAdded}
                newCityAdded={newCityAdded}
                suburbId={suburbId}
                handleCancelBulk={handleCancelBulk}
              />
            </Modal>
            {authUserData()?.permission.includes("common|delete_suburb") && (
              <>
                {selectedRow.length > 0 && (
                  <Popconfirm
                    className="action"
                    title={t("pop_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleArchive()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={
                        <>
                          <div
                            className="BlueShadowBtn"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <ArchiveButtonicon />
                            <span>{t("pl_archive")}</span>
                          </div>
                        </>
                      }
                    />
                  </Popconfirm>
                )}
              </>
            )}
            {authUserData()?.permission.includes("common|delete_suburb") && (
              // <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/suburb/archive">
                <Archiveicon />
              </Link>
              // </Tooltip>
            )}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>
      <section className="grid-sec ">
        <div className="Package-body">
          <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={CityList}
            scroll={{ x: 600 }}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (totalCount) => `Total ${totalCount} items`,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default SuburbList;
